var _a, _b, _c;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { GetCollaboratorsRepository } from '../get-collaborators-repository';
import { QueryGroupMemberInFolderRepository } from '../query-group-member-in-folder-repository';
import { UpdateCollaboratorsRepository } from '../update-collaborators-repository';
let CollaboratorsServiceImpl = class CollaboratorsServiceImpl {
    constructor(_getCollaboratorsRepository, _updateCollaboratorsRepository, _queryGroupMemberInFolderRepository) {
        this._getCollaboratorsRepository = _getCollaboratorsRepository;
        this._updateCollaboratorsRepository = _updateCollaboratorsRepository;
        this._queryGroupMemberInFolderRepository = _queryGroupMemberInFolderRepository;
    }
    getGroupCollaborators(groupId, shareTypeAndId, pager) {
        return this._queryGroupMemberInFolderRepository.queryGroupMemberInFolder(groupId, shareTypeAndId, pager);
    }
    updateCollaborators(shareTarget, collaborators) {
        return this._updateCollaboratorsRepository.updateCollaborators(shareTarget, collaborators);
    }
    getCollaborators(shareTarget) {
        const { spaceId, folderId } = shareTarget;
        return this._getCollaboratorsRepository.getCollaborators(spaceId, folderId);
    }
};
CollaboratorsServiceImpl = __decorate([
    injectable(),
    __param(0, inject(GetCollaboratorsRepository)),
    __param(1, inject(UpdateCollaboratorsRepository)),
    __param(2, inject(QueryGroupMemberInFolderRepository)),
    __metadata("design:paramtypes", [typeof (_a = typeof GetCollaboratorsRepository !== "undefined" && GetCollaboratorsRepository) === "function" ? _a : Object, typeof (_b = typeof UpdateCollaboratorsRepository !== "undefined" && UpdateCollaboratorsRepository) === "function" ? _b : Object, typeof (_c = typeof QueryGroupMemberInFolderRepository !== "undefined" && QueryGroupMemberInFolderRepository) === "function" ? _c : Object])
], CollaboratorsServiceImpl);
export { CollaboratorsServiceImpl };
